var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtimLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 991.128,
    height: 350,
    viewBox: "0 0 991.128 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.977,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#814d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d0b77"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26511",
    "data-name": "Group 26511",
    transform: "translate(-464.436 -365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_481",
    "data-name": "Union 481",
    d: "M16934.5,3209V3034l151.545-87.5,55.527,32.072-25.658,19.845-29.766-17.239-121.48,70.162v59.5l105.441-58.9,37.086-20.547,54.771-30.388-12.576-23.536,85.1,6.213-42.2,74.069-12.838-24.024-72.258,40.062v157.863l-18.844,10.523-18.242-10.523V3094.338l-105.441,58.9v38.423l121.48,70.162,121.479-70.162v-99.728l29.969-52.819V3209l-151.551,87.5Zm187.932-59.635,37.084-21.25v74.672l-37.084,20.547Zm-104.74,53.322v-61.339l12.127-6.417,24.957-13.229v101.532Zm104.74-117.067,37.084-19.646v43.4l-37.084,22.052Z",
    transform: "translate(-16470.066 -2581.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M90.32,94.16V-56.369h52.646V-88.115H1.96v31.746H54.341V94.16Zm149.206,0V-56.369h52.646V-88.115H151.166v31.746h52.381V94.16Zm90.212-153.7c12.7,0,23.545-10.582,23.545-23.016,0-12.7-10.847-23.28-23.545-23.28a23.308,23.308,0,0,0-23.28,23.28A23.086,23.086,0,0,0,329.738-59.544ZM347.2,94.16V-39.173H312.807V94.16Zm205.82-137.3c-21.429,0-38.1,8.73-47.619,23.016-8.466-14.55-23.81-23.016-44.974-23.016-19.841,0-35.45,7.407-44.18,21.164v-17.2H381.854V94.16h34.392V24.848c0-22.487,12.434-37.3,33.333-37.3,18.519,0,29.63,11.9,29.63,32.011v74.6h34.127V24.319c0-21.958,12.7-36.508,33.333-36.508,18.783,0,29.63,12.169,29.63,32.275V94.16H610.69V12.679C610.69-20.655,589-43.142,553.018-43.142Z",
    transform: "translate(844.873 533.84)",
    fill: "#1d0b77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtimLoginIcon);
export default __webpack_public_path__ + "static/media/ttim_login_icon.fa89d7cf4552c33d72b34822b3a0108d.svg";
export { ForwardRef as ReactComponent };